module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-feeling-kiss-face-svgrepo-com.0252cba1.svg";